import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';
import { fieldFrameClasses } from './Input';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    small?: boolean;
    data?: Array<[string, string]>;
    highlight?: boolean;
    readOnly?: boolean;
    className?: string;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
    ({ small, data, highlight, className, ...props }, ref) => (
        <div className="text-form-text relative inline-block w-full">
            <select
                ref={ref}
                className={`
                w-full
                appearance-none
                ${fieldFrameClasses}
                bg-white
                px-2
                pr-10
                leading-normal
                focus:outline-none
                disabled:cursor-not-allowed
                disabled:bg-gray-100
                disabled:text-neutral-400
                ${small ? 'py-2' : 'py-4'}
                ${highlight ? 'border-warning' : ''}
                ${props.readOnly ? 'cursor-not-allowed' : ''}
                ${className || ''}
                `}
                {...props}
            >
                {data &&
                    data.map(([key, displayName]) => {
                        const value = key ?? '';
                        return (
                            <option key={value} value={value}>
                                {displayName}
                            </option>
                        );
                    })}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4">
                <FontAwesomeIcon icon={faAngleDown} className="h-4 w-4 fill-current" />
            </div>
        </div>
    )
);

Select.displayName = 'Select';

export default Select;
